/**
 * Application level password protection for Contentful driven content.
 *
 * The unlock state lives in one cookie per protected entry so that unlocking a
 * given item never grants access to a different one.
 */
export const UNLOCK_COOKIE_PREFIX = 'acx_pw_'

export const getUnlockCookieName = (entryId: string) => `${UNLOCK_COOKIE_PREFIX}${entryId}`

/** Generic copy for every failure mode, so the response never leaks why it failed. */
export const INVALID_PASSWORD_MESSAGE = 'The password entered is incorrect.'

export const UNLOCK_ERROR_MESSAGE = 'Something went wrong. Please try again.'

export const LOCKED_MESSAGE = 'Too many attempts. Please try again later.'

export const MAX_FAILED_ATTEMPTS = 5
export const LOCKOUT_WINDOW_MS = 15 * 60 * 1000
export const MAX_ATTEMPT_KEYS = 10000
export const MAX_ENTRY_ID_LENGTH = 100
